import { Empty, Button, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './EmptyState.css';

const { Text } = Typography;

interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
  image?: 'default' | 'simple' | 'custom';
  customImage?: React.ReactNode;
}

const EmptyState = ({
  icon,
  title = 'No data',
  description = 'There is nothing here yet.',
  actionText,
  onAction,
  image = 'simple',
  customImage,
}: EmptyStateProps) => {
  const getImage = () => {
    if (customImage) return customImage;
    if (icon) return <div className="empty-icon">{icon}</div>;
    if (image === 'simple') return Empty.PRESENTED_IMAGE_SIMPLE;
    return Empty.PRESENTED_IMAGE_DEFAULT;
  };

  return (
    <div className="empty-state">
      <Empty
        image={getImage()}
        description={
          <div className="empty-content">
            <Text strong className="empty-title">{title}</Text>
            <Text type="secondary" className="empty-description">{description}</Text>
          </div>
        }
      >
        {actionText && onAction && (
          <Button type="primary" icon={<PlusOutlined />} onClick={onAction}>
            {actionText}
          </Button>
        )}
      </Empty>
    </div>
  );
};

export default EmptyState;

